import withTranslation from "next-translate/withTranslation";
import dynamic from "next/dynamic";
import { Component, Suspense } from "react";
import gs from "styles/Global.module.css";

const Footer = dynamic(() => import("SanityComponents/Footer/Footer"), {
  suspense: true,
});

const AgencesSection = dynamic(
  () => import("components/v2/Annuaire/AgencesSection"),
  {
    suspense: true,
  }
);

const ListeDesAnnonces = dynamic(
  () => import("components/ListeDesAnnonces/ListeDesAnnonces.js"),
  { suspense: true }
);
const AveragePriceArea = dynamic(
  () => import("./InfosPrixLocalisation/AveragePriceArea"),
  { suspense: true }
);
const AveragePricesTable = dynamic(
  () => import("./InfosPrixLocalisation/AveragePricesTable"),
  { suspense: true }
);
const AveragePricesList = dynamic(
  () => import("./InfosPrixLocalisation/AveragePricesList"),
  { suspense: true }
);
class InfoCarteDesPrix extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      coordinates: {
        lat: <></>,
        lng: <></>,
      },
    };
  }

  render() {
    const { t, lang } = this.props.i18n;
    return (
      <>
        {!this.props.prices.region ? (
          <h1 className={gs.page__title}>
            {t("Prix immobilier partout au Maroc")}
          </h1>
        ) : null}
        <Suspense fallback={<></>}>
          <AveragePriceArea
            scrollingUp={this.props.scrollingUp}
            localisation={
              this.props.prices.quartier
                ? this.props.prices.quartier
                : this.props.prices.commune
                  ? this.props.prices.commune
                  : this.props.prices.province
                    ? this.props.prices.province
                    : this.props.prices.region
                      ? this.props.prices.region
                      : ""
            }
            prices={this.props.prices}
            indice_confiance_appartement={this.props.indice_confiance_appartement}
            indice_confiance_villa={this.props.indice_confiance_villa}
          />
        </Suspense>

        {this.props.prices.commune &&
          (this.props.annonces.length > 0 || this.props.loadingAnnonces) ? (
          <Suspense fallback={<></>}>
            <ListeDesAnnonces
              setTransactionToDisplay={this.props.setTransactionToDisplay}
              vendu={false}
              scrollToTopFunction={this.props.scrollingUp}
              commune={this.props.prices.commune}
              annonces={this.props.annonces}
              loadingAnnonces={this.props.loadingAnnonces}
            />
          </Suspense>
        ) : (
          <></>
        )}

        {this.props.prices.commune &&
          ((this.props.transactions && this.props.transactions.length > 0) ||
            this.props.loadingTransactions) ? (
          <Suspense fallback={<></>}>
            <ListeDesAnnonces
              vendu={true}
              setTransactionToDisplay={this.props.setTransactionToDisplay}
              scrollToTopFunction={this.props.scrollingUp}
              commune={this.props.prices.commune}
              annonces={this.props.transactions}
              loadingAnnonces={this.props.loadingTransactions}
            />
          </Suspense>
        ) : (
          <></>
        )}
        {/* {this.props.prices.commune ? (
          <Suspense fallback={<></>}>
            <AgencesSection
              displayEmptyPage={false}
              displayPagination={false}
              alternateLink={
                "https://agenz.ma/agence-immobiliere-maroc/recherche"
              }
            alternateLinkLabel={"Voir toutes les agences >"}
            />
          </Suspense>
        ) : (
          <></>
        )} */}

        {this.props.provinces.length > 0 ? (
          <AveragePricesTable
            isH1={!this.props.prices.prix_appartement & !this.props.prices.prix_villa}

            titre={
              this.props.from_server
                ? t("Le prix du m2 dans les grandes villes du Maroc")
                : `${this.props.prices.region.trim()} : ${t(
                  "prix immobiliers dans les principales villes"
                )}`
            }
            type={"provinces"}
            prices={this.props.provinces}
            loadingPrices={
              this.props.from_server ? false : this.props.loadingPrices
            }
          />
        ) : null}

        {this.props.communes.length > 0 ? (
          <AveragePricesTable
            isH1={!this.props.prices.prix_appartement & !this.props.prices.prix_villa}
            scrollingUp={this.props.scrollingUp}
            type={"communes"}
            titre={`${this.props.prices.province
              ? t(this.props.prices.province.trim())
              : this.props.prices.region
                ? t(this.props.prices.region.trim())
                : ""
              } : ${t("prix du m² par commune")}`}
            prices={this.props.communes}
            loadingPrices={this.props.loadingPrices}
          />
        ) : (
          <></>
        )
        }
        {
          this.props.provinces_maroc.length > 0 ? (
            <AveragePricesList
              type={t("provinces")}
              titre={`${this.props.prices.province
                ? this.props.prices.province.trim()
                : this.props.prices.region
                  ? this.props.prices.region.trim()
                  : ""
                } : ${t("prix du m² par commune")}`}
              prices={this.props.provinces_maroc}
              loadingPrices={false}
            />
          ) : (
            <></>
          )
        }
        <div style={{ padding: "32px 12px" }}>
          <Suspense fallback={<></>}>
            <Footer t={t} prix_immobilier={true} />
          </Suspense>
        </div>
      </>
    );
  }
}

export default withTranslation(InfoCarteDesPrix, "prixImmobilierMaroc");
